import { TEnvironment } from 'scw-digital-boards-widgets';
import packageJson from '../../../../package.json';

export interface IEnvironment {
  appInsights: {
    cloudRole: string;
    instrumentationKey: string | null;
  };
  production: boolean;
  signalRHubUrl: string;
  ssoAuthUrl: string;
  ssoEnv: string;
  ssoLogoutUrl: string;
  ssoSilentAuthUrl: string;
  ssoUrl: string;
  version: string;
  bookDemoUrl: string;
  env: TEnvironment;
}

export const defaultEnvironmentConfigs = {
  bookDemoUrl: 'https://scw.ai/book-demo/',
  production: true,
  signalRHubUrl: 'https://autopilot.scm3d.com/signalr',
  ssoAuthUrl: '/selfclient/auth/',
  ssoEnv: 'DEV',
  ssoLogoutUrl: '/selfclient/logout',
  ssoSilentAuthUrl: '/selfclient/extend/',
  ssoUrl: 'https://df-sso.scm3d.com',
  version: packageJson.version,
} as const;
